import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30c2e832")

_pushScopeId("data-v-30c2e832")
const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#example5" }),
  /*#__PURE__*/_createTextVNode(" Select with custom options slot ")
], -1)
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = { class: "bg-dark text-white rounded-1 mb-2 p-3" }
const _hoisted_5 = { class: "multiselect-single-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_CodeHighlighter2 = _resolveComponent("CodeHighlighter2")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, " Data: " + _toDisplayString(_ctx.example5.value), 1),
      _createVNode(_component_Multiselect, _mergeProps({
        modelValue: _ctx.example5.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.example5.value = $event))
      }, _ctx.example5), {
        singlelabel: _withId(({ value }) => [
          _createVNode("div", _hoisted_5, [
            _createVNode("img", {
              class: "character-label-icon",
              src: value.icon
            }, null, 8, ["src"]),
            _createTextVNode(" " + _toDisplayString(value.name), 1)
          ])
        ]),
        option: _withId(({ option }) => [
          _createVNode("img", {
            class: "character-option-icon",
            src: option.icon
          }, null, 8, ["src"]),
          _createTextVNode(" " + _toDisplayString(option.name), 1)
        ]),
        _: 1
      }, 16, ["modelValue"]),
      _createVNode(_component_CodeHighlighter2, null, {
        html: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.htmlCode), 1)
        ]),
        js: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.jsCode), 1)
        ]),
        _: 1
      })
    ])
  ]))
})